module.exports = __webpack_public_path__ + "static/sstep4-35c716ca0b336ab77401435b0f51d6a9.png";